import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './home/home.component';

// Home stays eager because it is the landing route: lazy-loading it would only add
// a round trip before first paint. Everything else is split out, so a visitor who
// never opens Insights or the API docs never downloads them.
const routes: Routes = [
  { path: 'home', component: HomeComponent },
  // The Data Explorer and the Quality Improvement tool were folded into Insights.
  // Old links still land on the indicators: a redirect keeps the query string, so
  // the period and area carry over, and an indicator named in it opens directly.
  { path: 'data-explorer', redirectTo: 'insights' },
  { path: 'quality-improvement', redirectTo: 'insights' },
  {
    path: 'data-extract',
    loadChildren: () => import('./data-extract/data-extract.module').then(m => m.DataExtractModule)
  },
  {
    path: 'outcomes-intro',
    loadComponent: () => import('./outcomes-redirect/outcomes-redirect.component').then(m => m.OutcomesRedirectComponent)
  },
  {
    path: 'outcomes',
    loadChildren: () => import('./outcomes/outcomes.module').then(m => m.OutcomesModule)
  },
  {
    path: 'insights',
    loadChildren: () => import('./strategic-view/strategic-view.module').then(m => m.StrategicViewModule)
  },
  {
    path: 'resources',
    loadComponent: () => import('./resources/resources.component').then(m => m.ResourcesComponent)
  },
  {
    path: 'methodology',
    loadComponent: () => import('./methodology/methodology.component').then(m => m.MethodologyComponent)
  },
  {
    path: 'about',
    loadComponent: () => import('./about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'quality-improvement-overview',
    loadComponent: () => import('./quality-improvement-overview/quality-improvement-overview.component').then(m => m.QualityImprovementOverviewComponent)
  },
  {
    path: 'quality-improvement-data-packs',
    loadComponent: () => import('./quality-improvement-data-packs/qi-data-packs.component').then(m => m.QiDataPacksComponent)
  },
  {
    path: 'outputs',
    loadComponent: () => import('./outputs/outputs.component').then(m => m.OutputsComponent)
  },
  {
    path: 'events',
    loadComponent: () => import('./events/events.component').then(m => m.EventsComponent)
  },
  {
    path: 'news',
    loadComponent: () => import('./news/news.component').then(m => m.NewsComponent)
  },
  {
    path: 'news/:slug',
    loadComponent: () => import('./news/news-article/news-article.component').then(m => m.NewsArticleComponent)
  },
  {
    path: 'api',
    loadChildren: () => import('./api/api.module').then(m => m.ApiModule)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./privacy-policy/privacy-policy.component').then(m => m.PrivacyPolicyComponent)
  },
  {
    path: 'maintenance',
    loadComponent: () => import('./maintenance/maintenance.component').then(m => m.MaintenanceComponent)
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home', pathMatch: 'full' }
]

// Comment out the above routes and comment in the below routes for maintenance screen
// const routes: Routes = [
//   {
//     path: 'maintenance',
//     loadComponent: () => import('./maintenance/maintenance.component').then(m => m.MaintenanceComponent)
//   },
//   { path: '**', redirectTo: 'maintenance' },
// ]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // Scrolling is handled by RouteScrollService instead. The router's own options
      // fire on every navigation and cannot tell a real one from a same-page URL
      // update, and Insights makes a lot of the latter: opening an indicator, its
      // metadata or a pathway each navigate only to record what is open, and were
      // throwing the page to an anchor or back to the top as a result.

      // The lazy chunks are fetched in the background once the app is idle on the
      // landing page, so navigating to a section is still instant despite the split.
      preloadingStrategy: PreloadAllModules
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { }
